import React from "react";
import FlexionChart from "./FlexionChart";
import { Paper, Typography } from "@mui/material";

// Lightweight wrapper to display a simple left/right line chart from legacy legAngleData structure
export default function AnglesChart({ title = "Leg Flex/Extension", height = "300px", data = [] }) {
  try {
    const leftSeries = Array.isArray(data) && data[0]?.data ? data[0].data : [];
    const rightSeries = Array.isArray(data) && data[1]?.data ? data[1].data : [];

    // Map legacy series arrays into timeSeriesData expected by FlexionChart
    const maxLen = Math.max(leftSeries.length, rightSeries.length);
    const timeSeriesData = Array.from({ length: maxLen }).map((_, i) => ({
      time: i,
      left: leftSeries[i] !== undefined ? leftSeries[i] : null,
      right: rightSeries[i] !== undefined ? rightSeries[i] : null,
    }));

    if (timeSeriesData.length === 0) {
      return (
        <Paper elevation={2} sx={{ p: 2, height, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography variant="body2" color="text.secondary">No data</Typography>
        </Paper>
      );
    }

    // Check if we have any valid data points
    const hasValidData = timeSeriesData.some(point => 
      (point.left !== null && point.left !== undefined && point.left !== 0) || 
      (point.right !== null && point.right !== undefined && point.right !== 0)
    );

    if (!hasValidData) {
      return (
        <Paper elevation={2} sx={{ p: 2, height, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography variant="body2" color="text.secondary">No valid data points</Typography>
        </Paper>
      );
    }

    return (
      <FlexionChart
        title={title}
        timeSeriesData={timeSeriesData}
        leftDataKey="left"
        rightDataKey="right"
        height={height}
        yAxisLabel={title}
        leftColor="#1E88E5"
        rightColor="#43A047"
      />
    );
  } catch (e) {
    return (
      <Paper elevation={2} sx={{ p: 2, height, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography variant="body2" color="text.secondary">Unable to render chart</Typography>
      </Paper>
    );
  }
}
